import React from "react";
import {useNavigate} from "react-router-dom";
import {s} from './style';
import notFoundIcon from "@shared/assets/icons/error/not-found-icon.svg"
import SizedBox from "@shared/ui/sized-box";
import {Colors} from "@shared/styles/colors";
import {clearSession} from "@shared/utils/clear-session";


function NotFoundPage() {
    const navigate = useNavigate();

    // "확인" 버튼 클릭 시 세션 정리 후 메인 페이지로 이동
    const handleConfirmClick = () => {
        clearSession();
        navigate("/"); // "/"로 이동 (필요 시 변경 가능)
    };

    return (
        <s.NotFoundPageLayout>
            <s.NotFoundContainer>
                <s.NotFoundIcon src={notFoundIcon} alt="Not Found"/>
                <SizedBox height={16}/>
                <s.TitleText>알림</s.TitleText>
                <SizedBox height={12}/>
                <s.ContentText>정보를 불러올 수 없어요.</s.ContentText>
                <SizedBox height={20}/>
                <s.OkButton
                    onClick={handleConfirmClick}
                    $backgroundColor={Colors.mediumPurple2}
                    $buttonTextColor={Colors.defaultContainerColor}
                >
                    확인
                </s.OkButton>
            </s.NotFoundContainer>
        </s.NotFoundPageLayout>
    );
}

export default NotFoundPage;
